import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    viewModeContainer: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "12px",
    },
    customSelect: {
      width: "150px",
    },
    switcherBox: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "24px",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
      },
    },
  };
});
